import React from 'react';
import { MetricValue } from '../../atoms/MetricValue';
import styles from './MetricItem.module.css';

interface MetricItemProps {
  value: string;
  caption: string;
  className?: string;
}

export const MetricItem: React.FC<MetricItemProps> = ({
  value,
  caption,
  className,
}) => {
  return (
    <div className={`${styles.metricItem} ${className || ''}`}>
      <MetricValue value={value} />
      <p className={styles.caption}>{caption}</p>
    </div>
  );
};
